<template>
  <div class="pctl">
    <h5 class="pctl__title">Complete The Look</h5>
    <div class="pctl__products-wrapper swiper-container">
      <div :class="['pctl__products', { center: products.length < 4 }]">
        <div v-for="(product, index) in products" :key="index" class="pctl__product">
          <ProductCard type="TypeC" :product="product" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onUpdated } from 'vue';
  import ProductCard from '../../global/product-card/index.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    products: {
      type: Array,
      default: [],
    },
  });

  const productSlider = ref(null);

  onMounted(() => {
    productSlider.value = new Swiper('.pctl__products-wrapper', productCarousel.value);
  });

  onUpdated(() => {
    setTimeout(() => {
      productSlider.value?.destroy();
      productSlider.value = new Swiper('.pctl__products-wrapper', productCarousel.value);
    }, 100);
  });

  const productCarousel = computed(() => {
    return {
      slidesPerView: 1.6,
      spaceBetween: 16,
      wrapperClass: 'pctl__products',
      slideClass: 'pctl__product',
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 2.8,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      a11y: {
        enabled: true,
        slideLabelMessage: `Click on this product to open quick view dialog, product slide {{index}} / {{slidesLength}}`,
      },
    };
  });

  // const ctlTestVar = ref(null);

  // onMounted(() => {
  //   // for A/B test
  //   window.optimizelyTestAppliedHandlers.register([
  //     'ctlTest', variationName => {
  //       ctlTestVar.value = variationName;
  //     },
  //   ]);

  //   setTimeout(() => {
  //     if(showCtlTest.value){
  //       document.querySelector('#product-wrapper').classList.add('ctl--test')
  //     }
  //   },100)
  // })

  // const showCtlTest = computed(() => {
  //   return ctlTestVar.value === 'variation' && products.value.length
  // })
</script>
